(function () {
  'use strict';

  var root = document.getElementById('TrackOrder');
  if (!root) return;

  var apiUrl = root.dataset.apiUrl;
  var currency = root.dataset.currency || 'GBP';
  var form = document.getElementById('trackOrderForm');
  var searchType = document.getElementById('to_search_type');
  var searchValue = document.getElementById('to_search_value');
  var searchLabel = document.getElementById('to_search_label');
  var orderInput = document.getElementById('to_order_id');
  var submitBtn = document.getElementById('to-search-btn');
  var messageEl = document.getElementById('to-message');
  var loader = root.querySelector('.to-loader');
  var results = document.getElementById('to-results');

  var SEARCH_FIELDS = {
    postal_code: { label: 'Postal Code', placeholder: 'EC1A 1AA', inputmode: 'text' },
    email: { label: 'Email', placeholder: 'name@example.com', inputmode: 'email' },
    phone_number: { label: 'Phone Number', placeholder: 'Enter last 4 digits of your mobile number', inputmode: 'numeric' },
  };

  var PLACEHOLDER_IMAGE = 'https://cdn.shopify.com/s/images/admin/no-image-large.gif';

  // ---------- Helpers ----------

  function escapeHtml(value) {
    if (value === null || value === undefined) return '';
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function safeUrl(url) {
    return /^https?:\/\//i.test(url || '') ? url : '';
  }

  // API dates are "YYYY-MM-DD HH:MM:SS"; parse manually so Safari handles them.
  function parseDate(value) {
    var m = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?/.exec(value || '');
    if (!m) return null;
    return new Date(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0), +(m[6] || 0));
  }

  function formatDate(value, withTime) {
    var d = parseDate(value);
    if (!d) return escapeHtml(value);
    var opts = { day: 'numeric', month: 'short', year: 'numeric' };
    if (withTime) {
      opts.hour = '2-digit';
      opts.minute = '2-digit';
    }
    return d.toLocaleString('en-GB', opts);
  }

  function formatMoney(amount) {
    if (amount === null || amount === undefined || amount === '') return '';
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency }).format(amount);
    } catch (e) {
      return Number(amount).toFixed(2);
    }
  }

  function humanise(value) {
    if (!value) return '';
    return String(value)
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/\b\w/g, function (c) {
        return c.toUpperCase();
      });
  }

  function badgeVariant(status) {
    var s = String(status || '').toLowerCase();
    if (/declin|cancel|fail|exception|return(ed)? to sender|undeliver/.test(s)) return 'danger';
    if (/deliver|refund|approv|accept|fulfil|paid|exchang|store credit|collected/.test(s)) return 'success';
    if (/pending|unfulfil|await|partial/.test(s)) return 'warning';
    return 'info';
  }

  function badge(status) {
    if (!status) return '';
    return (
      '<span class="to-badge to-badge--' + badgeVariant(status) + '">' + escapeHtml(humanise(status)) + '</span>'
    );
  }

  function isDelivered(shipment) {
    if (/deliver/i.test(shipment.status || '') && !/out for|undeliver|attempt/i.test(shipment.status || '')) return true;
    var events = shipment.events || [];
    var last = events[events.length - 1];
    return !!(last && /^delivered/i.test(last.event_name || ''));
  }

  // ---------- Form behaviour ----------

  function updateSearchField() {
    var cfg = SEARCH_FIELDS[searchType.value];
    searchLabel.textContent = cfg.label;
    searchValue.placeholder = cfg.placeholder;
    searchValue.setAttribute('inputmode', cfg.inputmode);
    searchValue.value = '';
    setFieldError('search_value', '');
  }

  function setFieldError(name, message) {
    var input = name === 'order_id' ? orderInput : searchValue;
    var msg = root.querySelector('[data-msg-for="' + name + '"]');
    input.classList.toggle('to-invalid', !!message);
    msg.textContent = message || '';
  }

  // Mirrors the API's validation rules so most mistakes are caught before a request.
  function validate() {
    var ok = true;
    var orderId = orderInput.value.trim().replace(/^#/, '');
    var value = searchValue.value.trim();

    setFieldError('order_id', '');
    setFieldError('search_value', '');

    if (!orderId) {
      setFieldError('order_id', 'Please enter your order ID.');
      ok = false;
    } else if (!/^[A-Za-z0-9-]+$/.test(orderId)) {
      setFieldError('order_id', 'Order ID can only contain letters, numbers and hyphens.');
      ok = false;
    }

    if (searchType.value === 'email') {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        setFieldError('search_value', 'Please enter a valid email address.');
        ok = false;
      }
    } else if (searchType.value === 'phone_number') {
      if (!/^\d{4,15}$/.test(value.replace(/\s/g, ''))) {
        setFieldError('search_value', 'Please enter at least the last 4 digits of your mobile number.');
        ok = false;
      }
    } else if (!/^[A-Za-z0-9 -]{3,10}$/.test(value)) {
      setFieldError('search_value', 'Postal code must be 3–10 letters, numbers, spaces or hyphens.');
      ok = false;
    }

    return ok;
  }

  function showMessage(text) {
    messageEl.textContent = text;
    messageEl.hidden = !text;
  }

  function setLoading(isLoading) {
    submitBtn.disabled = isLoading;
    submitBtn.classList.toggle('is-loading', isLoading);
    loader.hidden = !isLoading;
    if (isLoading) results.hidden = true;
  }

  // ---------- API ----------

  function track(payload) {
    showMessage('');
    setLoading(true);

    return fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        return res
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            if (res.status === 429) {
              throw new Error(
                (data && data.message) || 'Too many attempts. Please wait a minute and try again.'
              );
            }
            if (!res.ok) throw new Error('Something went wrong. Please try again later.');
            return data;
          });
      })
      .then(function (data) {
        if (!data || data.error) {
          throw new Error((data && data.message) || 'Order not found or the details entered do not match.');
        }
        render(data);
      })
      .catch(function (err) {
        showMessage(
          err && err.message && err.message !== 'Failed to fetch'
            ? err.message
            : 'Unable to reach the tracking service. Please try again later.'
        );
      })
      .then(function () {
        setLoading(false);
      });
  }

  // ---------- Rendering ----------

  function renderItem(item, extra) {
    var meta = [];
    if (item.colour) meta.push('<span>Colour: ' + escapeHtml(item.colour) + '</span>');
    if (item.size) meta.push('<span>Size: ' + escapeHtml(item.size) + '</span>');
    if (item.quantity) meta.push('<span>Qty: ' + escapeHtml(item.quantity) + '</span>');

    return (
      '<li class="to-item">' +
      '<img src="' + escapeHtml(safeUrl(item.image) || PLACEHOLDER_IMAGE) + '" alt="' + escapeHtml(item.name) + '" loading="lazy" width="72" height="96">' +
      '<div class="to-item-info">' +
      '<div class="to-item-name">' + escapeHtml(item.name) + '</div>' +
      (item.sku ? '<div class="to-item-meta">SKU: ' + escapeHtml(item.sku) + '</div>' : '') +
      (meta.length ? '<div class="to-item-meta">' + meta.join('') + '</div>' : '') +
      (extra || '') +
      '</div>' +
      '</li>'
    );
  }

  function renderTimeline(tracking) {
    var events = (tracking.events || []).slice().reverse(); // newest first
    var url = safeUrl(tracking.tracking_url);

    if (!events.length) {
      return (
        '<div class="to-empty">' +
        '<p>' +
        (tracking.tracking_number
          ? 'Detailed tracking updates are available on the ' + escapeHtml(tracking.delivery_partner || 'carrier') + ' website.'
          : 'Tracking details will appear here once your parcel is with the carrier.') +
        '</p>' +
        (url
          ? '<a class="to-btn to-btn--outline" href="' + escapeHtml(url) + '" target="_blank" rel="noopener">Track with ' + escapeHtml(tracking.delivery_partner || 'carrier') + '</a>'
          : '') +
        '</div>'
      );
    }

    return (
      '<ol class="to-timeline">' +
      events
        .map(function (ev, i) {
          var meta = [formatDate(ev.event_date_time, true)];
          if (ev.location_name) meta.push(escapeHtml(ev.location_name));
          return (
            '<li class="to-event' + (i === 0 ? ' is-latest' : '') + '">' +
            '<div class="to-event-name">' + escapeHtml(ev.event_name) + '</div>' +
            '<div class="to-event-meta">' + meta.join(' · ') + '</div>' +
            '</li>'
          );
        })
        .join('') +
      '</ol>'
    );
  }

  function trackingMeta(tracking) {
    var parts = [];
    if (tracking.delivery_partner) parts.push(escapeHtml(tracking.delivery_partner));
    if (tracking.tracking_number) {
      var url = safeUrl(tracking.tracking_url);
      parts.push(
        url
          ? '<a href="' + escapeHtml(url) + '" target="_blank" rel="noopener">' + escapeHtml(tracking.tracking_number) + '</a>'
          : escapeHtml(tracking.tracking_number)
      );
    }
    return parts.join(' · ');
  }

  function renderSummary(order, fulfilment) {
    var shipped = fulfilment.length > 0;
    var delivered = shipped && fulfilment.every(isDelivered);
    var steps = [
      { label: 'Order placed', done: true },
      { label: 'Dispatched', done: shipped },
      { label: 'Delivered', done: delivered },
    ];

    return (
      '<div class="to-card">' +
      '<h2 class="to-section-title">Order ' + escapeHtml(order.order_name) + '</h2>' +
      '<div class="to-section-body">' +
      '<div class="to-summary">' +
      '<div class="to-summary-item"><span>Order date</span><strong>' + formatDate(order.order_date) + '</strong></div>' +
      '<div class="to-summary-item"><span>Payment</span>' + badge(order.financial_status) + '</div>' +
      '<div class="to-summary-item"><span>Fulfilment</span>' + badge(order.fulfillment_status || 'unfulfilled') + '</div>' +
      '</div>' +
      '<div class="to-progress">' +
      steps
        .map(function (s) {
          return (
            '<div class="to-step' + (s.done ? ' is-done' : '') + '"><span class="to-step-dot"></span>' + s.label + '</div>'
          );
        })
        .join('') +
      '</div>' +
      '</div>' +
      '</div>'
    );
  }

  function renderShipments(items, fulfilment) {
    var byId = {};
    items.forEach(function (item) {
      byId[item.id] = item;
    });

    var shippedIds = {};
    var blocks = fulfilment.map(function (shipment, index) {
      var shipmentItems = (shipment.item_ids || [])
        .map(function (id) {
          shippedIds[id] = true;
          return byId[id];
        })
        .filter(Boolean);

      return (
        '<div class="to-block">' +
        '<div class="to-block-head">' +
        '<div><h3>Parcel ' + (index + 1) + (fulfilment.length > 1 ? ' of ' + fulfilment.length : '') + '</h3>' +
        '<div class="to-block-meta">' + (trackingMeta(shipment) || 'Awaiting tracking details') + '</div></div>' +
        badge(shipment.status || 'Processing') +
        '</div>' +
        '<div class="to-block-body">' +
        '<ul class="to-items">' + shipmentItems.map(function (it) { return renderItem(it); }).join('') + '</ul>' +
        renderTimeline(shipment) +
        '</div>' +
        '</div>'
      );
    });

    var pending = items.filter(function (item) {
      return !shippedIds[item.id];
    });
    if (pending.length) {
      blocks.push(
        '<div class="to-block">' +
        '<div class="to-block-head"><div><h3>' + (fulfilment.length ? 'Not yet dispatched' : 'Preparing your order') + '</h3>' +
        '<div class="to-block-meta">These items will be shown with tracking once they are dispatched.</div></div>' +
        badge('Awaiting dispatch') +
        '</div>' +
        '<div class="to-block-body to-block-body--single">' +
        '<ul class="to-items">' +
        pending
          .map(function (it) {
            return renderItem(it);
          })
          .join('') +
        '</ul>' +
        '</div>' +
        '</div>'
      );
    }

    return (
      '<div class="to-card">' +
      '<h2 class="to-section-title">Delivery</h2>' +
      '<div class="to-section-body">' + blocks.join('') + '</div>' +
      '</div>'
    );
  }

  function renderReturns(items, returns) {
    if (!returns.length) return '';

    var images = {};
    items.forEach(function (item) {
      images[item.id] = item;
    });

    var blocks = returns.map(function (request) {
      var returnItems = (request.items || []).map(function (ri) {
        var orderItem = images[ri.id] || {};
        var extra =
          '<div class="to-item-badges">' +
          badge(ri.item_status) +
          (ri.refund_status ? badge(ri.refund_status) : '') +
          '</div>' +
          (ri.refund_amount !== null && ri.refund_amount !== undefined
            ? '<div class="to-refund-amount">Refund: ' + escapeHtml(formatMoney(ri.refund_amount)) + '</div>'
            : '');

        var html = renderItem(
          {
            name: ri.name || orderItem.name,
            sku: ri.sku || orderItem.sku,
            colour: orderItem.colour,
            size: orderItem.size,
            quantity: ri.quantity,
            image: orderItem.image,
          },
          extra
        );

        if (ri.return_tracking) {
          html +=
            '<li class="to-return-tracking">' +
            '<div class="to-block-meta" style="margin-bottom:10px">Return parcel: ' + trackingMeta(ri.return_tracking) +
            (ri.return_tracking.status ? ' ' + badge(ri.return_tracking.status) : '') +
            '</div>' +
            renderTimeline(ri.return_tracking) +
            '</li>';
        }
        return html;
      });

      return (
        '<div class="to-block">' +
        '<div class="to-block-head">' +
        '<div><h3>Return request</h3><div class="to-block-meta">Requested ' + formatDate(request.requested_date) + '</div></div>' +
        badge(request.request_status) +
        '</div>' +
        '<div class="to-block-body to-block-body--single"><ul class="to-items">' + returnItems.join('') + '</ul></div>' +
        '</div>'
      );
    });

    return (
      '<div class="to-card">' +
      '<h2 class="to-section-title">Returns &amp; Refunds</h2>' +
      '<div class="to-section-body">' + blocks.join('') + '</div>' +
      '</div>'
    );
  }

  function render(data) {
    var items = data.items || [];
    var fulfilment = data.fulfilment || [];
    var returns = data.returns || [];

    results.innerHTML =
      renderSummary(data.order || {}, fulfilment) +
      renderShipments(items, fulfilment) +
      renderReturns(items, returns);
    results.hidden = false;
    results.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ---------- Init ----------

  searchType.addEventListener('change', updateSearchField);

  searchValue.addEventListener('input', function () {
    if (searchType.value === 'phone_number') {
      searchValue.value = searchValue.value.replace(/[^0-9]/g, '');
    }
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (submitBtn.disabled || !validate()) return;

    track({
      order_id: orderInput.value.trim(),
      search_type: searchType.value,
      search_value: searchValue.value.trim(),
    });
  });

  updateSearchField();

  // Auto-search from URL params:
  //   ?order_id=5849&email=name@example.com  (account order page link, guest email check)
  //   ?order_id=<shopify order id>&customer_id=<shopify customer id>  (customer mode)
  var params = new URLSearchParams(window.location.search);
  var paramOrderId = (params.get('order_id') || '').trim();
  var paramEmail = (params.get('email') || '').trim();
  var paramCustomerId = (params.get('customer_id') || '').trim();

  if (paramOrderId) orderInput.value = paramOrderId;

  if (paramOrderId && paramEmail) {
    searchType.value = 'email';
    updateSearchField();
    searchValue.value = paramEmail;
    if (validate()) {
      track({ order_id: paramOrderId, search_type: 'email', search_value: paramEmail });
    }
  } else if (/^\d+$/.test(paramOrderId) && /^\d+$/.test(paramCustomerId)) {
    track({ order_id: paramOrderId, customer_id: paramCustomerId });
  }
})();
